module.exports = __webpack_public_path__ + "img/sb07.39259976.png";